import { Dispatch } from 'react';
import { ArchivedProjectBrowserModel, PostDispatch } from '../../types';
import {
    GET_ARCHIVED_PROJECTS,
    GET_ARCHIVED_PROJECT,
    GET_VISIBLE_ARCHIVED_PROJECTS,
    REMOVE_ARCHIVED_PROJECT,
} from '../types';
import { SuSyApi } from '../../../api/susyApi';
import { transformDateFormat } from 'susy-common/date-utils';
import { ArchiveProjectVisibilityRequest } from 'susy-common/models';

export const getAllArchiveProjects =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const { data } = await SuSyApi.get(`/archive/projects`);
        dispatch({ type: GET_ARCHIVED_PROJECTS, payload: data });
    };

export const getVisibleArchiveProjects =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const { data } = await SuSyApi.get(`/archive/visibleProjects`);

        dispatch({ type: GET_VISIBLE_ARCHIVED_PROJECTS, payload: data });
    };

export const updateArchivedProjectVisibility =
    (projects: Array<ArchivedProjectBrowserModel>) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const archiveProjectVisibilities: ArchiveProjectVisibilityRequest[] =
            projects.map((project) => {
                return {
                    _id: project._id,
                    isVisibleToEveryone: project.isVisibleToEveryone,
                };
            });
        const response = await SuSyApi.patch(
            `/archive/project/visibility`,
            archiveProjectVisibilities
        );
        dispatch({
            type: GET_ARCHIVED_PROJECTS,
            payload: response.data,
        });
    };

export const getArchivedProject =
    (projectId: string | null) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/archive/project/${projectId}`);
        dispatch({
            type: GET_ARCHIVED_PROJECT,
            payload: transformDateFormat(response.data),
        });
    };

export const removeArchivedProjectFromStore = (projectId: string | null) => ({
    type: REMOVE_ARCHIVED_PROJECT,
    payload: { projectId },
});
